import React, { useMemo } from 'react';
import cx from 'classnames';
import Card from '../../Card';
import style from './header.module.scss';

const Header = ({ steps = [], currentStep, isMobile, isHeaderClickActive, onStepClick }) => {

	const getStep = ({ step, index }) => {
		const icon = !isMobile && (currentStep >= index ? step?.activeStepIcon : step?.stepIcon);
		const title = step?.title;

		const handleOnStepClick = () => {
			if (isHeaderClickActive) {
				onStepClick && onStepClick(index);
			}
		};

		return (
			<div className={style.stepContainer} key={index}>
				<div className={style.stepClickArea} onClick={handleOnStepClick}>
					{icon || <div className={cx(style.step, {
						[style.currentStep]: currentStep === index
					})}>{index + 1}</div>}
					{title && <div
						className={cx(style.title, {
							[style.active]: currentStep >= index,
							[style.currentStep]: currentStep === index
						})}>{title}</div>}
				</div>
				{index !== steps.length - 1 && <div className={style.divider} />}
			</div>
		);
	};

	const activeSteps = useMemo(() => steps?.filter((step, index) => index <= currentStep), [currentStep]);
	const notActiveSteps = useMemo(() => steps?.filter((step, index) => index > currentStep), [currentStep]);

	return (
		<Card className={cx(style.container, { [style.isMobile]: isMobile })} customContentClass={style.content}>
			<div className={style.activeSteps}>
				{
					activeSteps?.map((step, index) => {
						return getStep({ step, index });
					})
				}
			</div>
			<div className={style.notActiveSteps}>
				{
					notActiveSteps?.map((step, index) => {
						return getStep({ step, index: index + activeSteps.length });
					})
				}
			</div>
		</Card>
	);
};

export default Header;
